module.exports = __webpack_public_path__ + "static/media/up-arrow.175ccbf9.svg";